export async function getListWithFilter({commit}, payload = {}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.appUserCampaigns.index(payload);
  if (!errResponse) {
    return responseData.data;
  }

  return [];
}

export async function getAllCampaigns({commit}, payload = {}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.appUserCampaigns.index(payload);
  if (!errResponse) {
    commit('setAllCampaigns', responseData.data);
    return responseData.data;
  }

  return [];
}
